import { DefaultTheme } from "styled-components";

export interface IDayAction {
    color: keyof DefaultTheme;
    title: string;
    categoryId: number;
    isFullDay: boolean;
    isStart: boolean;
    isEnd: boolean;
    hasConflict?: boolean;
    hideTitle?: boolean;
    isPlaceholder?: boolean;
    order?: number;
}

export const TileSize = {
    MIN: 60,
    BREAK: 80,
    BREAK_L: 104,
    MAX: 140
};
